import { WithTheme } from '@issuemanager/apps/client/theme';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  AccordionSummaryProps,
} from '@mui/material';
import { styled } from '@mui/system';
import React from 'react';

const StyledAccordion = styled(Accordion)`
  border-radius: 6px;
  border: 1px solid #c4c4c4;
`;

const StyledAccordionSummary = styled(AccordionSummary)<
  WithTheme<AccordionSummaryProps>
>`
  padding: ${({ theme }) => theme.spacing(1)};
  && {
    .MuiAccordionSummary-content {
      justify-content: start;
      font-size: ${({ theme }) => theme.typography.body2.fontSize};
      line-height: ${({ theme }) => theme.typography.body2.lineHeight};
    }
  }
`;

const StyledAccordionDetails = styled(AccordionDetails)`
  padding: ${({ theme }) => `0 ${theme.spacing(1)} ${theme.spacing(1)}`};
`;

type Props = React.PropsWithChildren & {
  header: string;
};

export function CollapsibleField(props: Props) {
  const { header, children } = props;

  return (
    <StyledAccordion
      defaultExpanded
      data-atlas-alignment='end'
      data-testid='issue-information-data'
      disableGutters
    >
      <StyledAccordionSummary>{header}</StyledAccordionSummary>
      <StyledAccordionDetails>{children}</StyledAccordionDetails>
    </StyledAccordion>
  );
}
